import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();
  const { hash, key } = location;

  // Depend on location.key so every navigation re-fires this effect, even
  // when the user clicks a Link to the URL they are already on (same
  // pathname/search/hash). React Router 6 generates a new key per click.
  useEffect(() => {
    if (hash) {
      const id = hash.replace(/^#/, '');
      // Wait one frame so the target is in the DOM after a cross-route nav
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo(0, 0);
        }
      });
      return;
    }
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return null;
}
